module.exports = __webpack_public_path__ + "2cfba944.svg";